<template>

    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <div v-if="cardmodalshow==true"
             :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
             class="modal fade bd-example-modal-xl show " id="exampleModalLong" role="dialog"
             aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div style="max-width: 1000px!important;" class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <!--                        <div class="modal-header">-->
                    <!--                            <h5 class="modal-title" id="exampleModalLongTitle">Registration</h5>-->

                    <!--                        </div>-->
                    <div class="modal-body">

                        <form id="register">
                            <div class="banner">

                            </div>
                            <div>
                                <h4 :style="$i18n.locale == 'العربية' ?'margin-top:2%;margin-bottom:2%;text-align:right;font-family: Cairo,sans-serif !important;':'margin-top:2%;margin-bottom:2%;text-align:left;font-family: Comfortaa!important;'">
                                    {{
                                        $i18n.locale == 'العربية' ? 'بطاقة ماركت إكويتي مسبقة الدفع ' : 'Market Equity Prepaid Card'

                                    }}</h4>
                            </div>
                            <!--                            <div>-->
                            <!--                                <h4 :style="$i18n.locale == 'العربية' ?'margin-top:2%;margin-bottom:2%;text-align:right;font-family: Cairo,sans-serif !important;':'margin-top:2%;margin-bottom:2%;text-align:left;font-family: Comfortaa!important;'">-->
                            <!--                                    {{-->
                            <!--                                        $i18n.locale == 'العربية' ? ' سجل الآن' : 'Registration'-->
                            <!--                                    }}</h4></div>-->
                            <div class="form-group row">
                                <label
                                    :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"
                                    for="inputPassword"
                                    class="col-sm-2 col-form-label">
                                    {{ $i18n.locale == 'العربية' ? 'الاسم الكامل' : 'Full Name' }}
                                </label>

                                <input v-bind:class="{ 'is-invalid': nameError }"
                                       :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"
                                       type="text" class="form-control" id="inputPassword"
                                       v-model="registername">
                            </div>
                            <div class="form-group row">
                                <label
                                    :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"
                                    for="inputPassword"
                                    class="col-sm-6 col-form-label">
                                    {{
                                        $i18n.locale == 'العربية' ? 'هل انت عميل لدينا؟' : 'Are you an existing client? '
                                    }}
                                </label>


                            </div>
                            <div class="control-group"
                                 :style="$i18n.locale == 'العربية' ? 'margin-right:2%!important;text-align:right!important;':'margin-left:2%!important;text-align:left!important;'">
                                <div clas="controls">
                                    <div class="radio">
                                        <input style="width: 20px!important;" id="existingyes" name="existingyes"
                                               type="radio" v-model="userexists"
                                               @change="changevalue()"
                                        >
                                        <label
                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'">
                                            {{ $i18n.locale == 'العربية' ? 'نعم' : 'Yes ' }}
                                        </label>

                                    </div>
                                </div>
                            </div>
                            <div class="control-group"
                                 :style="$i18n.locale == 'العربية' ? 'margin-right:2%!important;text-align:right!important;':'margin-left:2%!important;text-align:left!important;'">
                                <div clas="controls">
                                    <div class="radio">
                                        <input style="width: 20px!important;" id="existingno" name="existingyes"
                                               @change="changevalueno()"
                                               type="radio" value="existingno" v-model="userexistsno" >

                                        <label
                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'">
                                            {{ $i18n.locale == 'العربية' ? 'لا' : 'No' }}
                                        </label>

                                    </div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="userexists">
                                <div v-if="gifshow==true"
                                     :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
                                     class="modal fade bd-example-modal-xl show" id="exampleModalLongvideo"
                                     tabindex="-1" role="dialog"
                                     aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                                    <div style="max-width: 1000px!important;" class="modal-dialog modal-xl"
                                         role="document">
                                        <div class="modal-content">
                                            <!--                        <div class="modal-header">-->
                                            <!--                            <h5 class="modal-title" id="exampleModalLongTitle">Registration</h5>-->

                                            <!--                        </div>-->


                                            <div class="modal-body" style=" max-height: calc(80vh - 60px)!important;
    overflow-y: auto;">

                                                <a href="https://devbackup.marketequityinc.com/public/public/303/20231122062006portal.gif"><img
                                                    border="0" alt="CRM"
                                                    src="https://devbackup.marketequityinc.com/public/public/303/20231122062006portal.gif"
                                                    width="100%" height="100%"></a>
                                            </div>

                                            <button type="button" class="btn btn-secondary" @click="gifclose"> {{
                                                    $i18n.locale == 'العربية' ? 'إغلاق   ' : 'Close'
                                                }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <label
                                    :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"
                                    for="inputPassword"
                                    class="col-sm-6 col-form-label">
                                    {{ $i18n.locale == 'العربية' ? 'رمز تعريف العميل  ' : 'Client ID' }}
                                    <span style="background:white;
    border-radius:50%;
    /*border: 2px solid black; !* Add border property with desired color and width *!*/
    height: 26px;
    width: 26px;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 6px;
    color:red;
    font-weight:bold" @click="mouseover">!</span>
                                </label>

                                <input v-bind:class="{ 'is-invalid': acnumberError }"
                                       :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"
                                       type="text" class="form-control"
                                       id="acnumber"
                                       v-model="acnumber">

                            </div>

                            <div class="form-group row">
                                <label
                                    :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"
                                    class="col-sm-6 col-form-label">{{
                                        $i18n.locale == 'العربية' ? 'عنوان البريد الالكترونى' : 'Email Address'
                                    }}</label>

                                <input v-bind:class="{ 'is-invalid': emailError }"
                                       :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"
                                       type="text" class="form-control" id="inputemail"
                                       v-model="registeremail">

                                <!-- Button trigger modal -->


                                <!-- Modal -->
                            </div>


                            <div class="form-group row">
                                <label
                                    :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;text-align: right; font-size: 16px;' :'font-family: Comfortaa!important;text-align: left; font-size: 16px;'"
                                    class="col-sm-2 col-form-label">{{
                                        $i18n.locale == 'العربية' ? 'رقم الهاتف' : 'Mobile'
                                    }}</label>
                                <input v-bind:class="{ 'is-invalid': phoneError }"
                                       :style="$i18n.locale == 'العربية' ? 'margin-right:1%;margin-left:1%':'margin-left:1%;margin-right:1%;'"
                                       type="text" class="form-control" id="inputmobile"
                                       v-model="registermobile">


                            </div>
                            <p style="color:red;" if="registererror">{{ this.registererror }}</p>

                            <div class="form-group row" style="text-align: center !important;" v-if="userexists">
                                <div class="btn-block" style="display: flex; flex-wrap: wrap; justify-content: center;">

                                    <button id="virtual"
                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important; margin: 1%;' : 'font-family: Comfortaa!important; margin: 1%;'"
                                        @click="cardtype(1)" type="button">
                                        {{ $i18n.locale == 'العربية' ? 'بطاقة رقمية ' : 'Virtual Card' }}
                                    </button>

                                    <button id="debit"
                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important; margin: 1%;' : 'font-family: Comfortaa!important; margin: 1%;'"
                                        @click="cardtype(2)" type="button">
                                        {{ $i18n.locale == 'العربية' ? 'بطاقة السحب الألي ' : 'Debit Card' }}
                                    </button>

                                    <button id="both"
                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important; margin: 1%;' : 'font-family: Comfortaa!important; margin: 1%;'"
                                        @click="cardtype(3)" type="button">
                                        {{ $i18n.locale == 'العربية' ? 'كلاهما  ' : 'Both' }}
                                    </button>

                                </div>
                            </div>


                            <div class="form-group row" style="text-align:center!important;">
                                <div class="btn-block" style="display: flex; flex-wrap: wrap; justify-content: center;">
                                    <button
                                        :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"
                                        @click="registergatetopay($i18n.locale)" type="button">
                                        {{ $i18n.locale == 'العربية' ? 'إرسال' : 'Submit' }}
                                    </button>
                                    <button @click="modalhide"
                                            :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;margin-right:1%;margin-left:1%':'font-family: Comfortaa!important;margin-left:1%;margin-right:1%;'"
                                            type="button" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true"> {{
                                                    $i18n.locale == 'العربية' ? 'إغلاق   ' : 'Close'
                                                }}
</span>
                                    </button>
                                </div>
                            </div>

                            <p v-if="userexists" style="text-align:center!important;"> {{
                                    $i18n.locale == 'العربية' ? 'كل فئة تخضع لرسوم دفع مختلفة ' : 'Each Category is Subject to Different Payment Fees'
                                }}
                            </p>
                            <p v-if="!userexists" style="text-align:center!important;"> {{
                                    $i18n.locale == 'العربية' ? 'للحصول على البطاقة مسبقة الدفع يجب أن يكون لديك حساب حقيقي ' : 'In order to acquire the pre-paid card, you need to have a real account. '
                                }}
                            </p>
                        </form>

                    </div>

                    <p style="color:green;" if="successregiter">{{ this.successregiter }}</p>
                </div>
            </div>
        </div>

        <Header/>

        <main
            :class="$i18n.locale=='العربية'?'page-main page-fullpage main-anim rtlclass':'page-main page-fullpage main-anim ltrclass'"
            id="mainpage"
            :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;margin-top:0;':'font-family: Comfortaa!important;margin-top:0;'">


            <!-- Begin of home section -->
            <div data-fp-styles="null" data-anchor="spotlight"
                 :class="$i18n.locale=='العربية'?'section  fp-section anim active section-anim rtlclass':'section  fp-section anim active section-anim ltrclass'"
                 data-section="home"
                 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;min-height:100vh!important':'font-family:Comfortaa!important!important;min-height:100vh!important'">

                <div
                    :class="$i18n.locale=='العربية'?'carousel bs-slider slide  control-round indicators-line  rtlclass':'carousel bs-slider slide  control-round indicators-line  ltrclass'"
                    id="bootstrap-touch-slider"
                    :style="$i18n.locale=='العربية'?'width:100%;height:100vh!important;margin-top:0px;font-family: GE SS Two Medium !important':'width:100%;height:100vh!important;margin-top:0px;font-family: Comfortaa!important'"
                    data-ride="carousel" data-pause="hover"
                    data-interval="5000">
                    <div class="section-wrapper fullwidth with-margin">

                        <!-- Wrapper For Slides -->
                        <div class="carousel-inner" style=" "
                             role="listbox">
                            <!-- Third Slide -->
                            <div class="item active"
                                 style="height:100vh!important;width:100%;font-family: Cairo,sans-serif !important;">

                                <div class="style__SpotlightItemStyled-vo40go-0 cDscbW"
                                     style="height:100vh;font-family: Cairo,sans-serif !important;">
                                    <figure style="height: 100vh;!important">
                                        <div aria-hidden="true" style="width:100%;padding-bottom:100%"></div>
                                        <img
                                            src="https://dev.marketequityinc.com/public/public/pagebanners/20231102082718.gif"
                                            alt="Market Equity"
                                            style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100vh!important;object-fit:cover;object-position:center"/>
                                    </figure>
                                    <div class="spotlight__info container" style="background-color:transparent;padding-top:10%;border:0px">
                                        <div class="react-reveal row"
                                             :style="$i18n.locale == 'العربية' ?'float: right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'float: left;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                            <div class="style__SectionTitleStyled-d40vxv-0 kcvceY col-sm ">
                                                <h2 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'">
                                                    {{
                                                        $i18n.locale == 'en' ? 'Prepaid MasterCard' : $i18n.locale == 'العربية' ? ' بطاقة ماستركارد مسبقة الدفع' : $i18n.locale == '中文' ? slidetitle1ch : $i18n.locale == 'Русский' ? 'Prepaid MasterCard' : 'Prepaid MasterCard'
                                                    }}</h2>
                                                <p :style="$i18n.locale == 'العربية' ?'margin-top:30px!important;float:right;font-size: 23px!important;text-transform: capitalize!important;font-family: Cairo,sans-serif !important;margin-right:4%':'margin-top:30px!important;float:left;font-size: 23px!important;text-transform: capitalize!important;font-family: Comfortaa!important;margin-left:4%'">


                                                    {{
                                                        $i18n.locale == 'en' ? ' Fast & Secure Withdrawals' : $i18n.locale == 'العربية' ? ' عمليات سحب آمنة وسريعة' : $i18n.locale == '中文' ? ' Fast & Secure Withdrawals' : ' Fast & Secure Withdrawals'
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="style__SpotlightThumbs-vo40go-1 lpdeLb col-sm"
                                             :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important':'float: left!important'">


                                        </div>
                                        <div class="btn_wrap"
                                             :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important':'float: left!important'">

                                            <div v-for="slidericonsone  in slidericonsactive" class="react-reveal"
                                                 :key="slidericonsone.titleen"
                                                 style="padding-left: 0%;padding-right:0%;max-width: 200px;margin-top:0px!important;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp">
                                                <div v-if="slidericonsone.sliderid==slider1id"
                                                     class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                     :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important':'float: left!important'">
                                                    <figure style="margin-bottom:-9px!important;">
                                                        <!--                                                        <a :href="$i18n.locale == 'en' ? '../en/'+slidericonsone.link : $i18n.locale == 'العربية' ? '../ar/'+slidericonsone.link : $i18n.locale == '中文' ? '../ch/'+slidericonsone.link : '../fr/'+slidericonsone.link">-->
                                                        <!--                                                            <img style="width:56px!important;height:56px!important"-->

                                                        <!--                                                                 src="serverurl+'/public/icons/'+slidericonsone.image"></a>-->
                                                    </figure>
                                                    <div>
                                                        <!--                                                        <h3-->
                                                        <!--                                                        :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'">-->
                                                        <!--                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;text-align:center!important':'font-family: Comfortaa!important;text-align:center!important'"-->
                                                        <!--                                                           :href="$i18n.locale == 'en' ? '../en/'+slidericonsone.link : $i18n.locale == 'العربية' ? '../ar/'+slidericonsone.link : $i18n.locale == '中文' ? '../ch/'+slidericonsone.link:$i18n.locale=='Русский'?'../ru/'+slidericonsone.link : '../fr/'+slidericonsone.link">-->

                                                        <!--                                                            {{-->
                                                        <!--                                                                $i18n.locale == 'en' ? slidericonsone.titleen : $i18n.locale == 'العربية' ? slidericonsone.titlear : $i18n.locale == '中文' ? slidericonsone.titlech : $i18n.locale == 'Русский' ? slidericonsone.titleru : slidericonsone.titlefr-->
                                                        <!--                                                            }}</a></h3>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="style__SpotlightThumbs-vo40go-1 lpdeLb col-sm"
                                             :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important':'float: left!important'">


                                        </div>
                                        <div class="btn_wrap"
                                             :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important;margin-top:-1%':'float: left!important;margin-top:-1%'">
                                            <div class="react-reveal"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                                <div
                                                    class="style__ButtonWrap-kitu94-0 hqzysg"
                                                    :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'">
                                                    <a @click="modalshow"
                                                       :style="$i18n.locale == 'العربية' ? 'color:#ffffff!important;font-family: Cairo,sans-serif !important;' :'color:#ffffff!important;font-family: Comfortaa!important;'"
                                                    ><span>


                                     {{
                                                            $i18n.locale == 'en' ? 'Request your Prepaid Card' : $i18n.locale == 'العربية' ? ' اطلب بطاقتك مسبقة الدفع ' : $i18n.locale == '中文' ? ' Request your Prepaid Card' : $i18n.locale == 'Русский' ? 'Request your Prepaid Card' : 'Request your Prepaid Card'
                                                        }}

                                            </span></a></div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                <!-- Slide Text Layer -->


                            </div>


                            <div class="item"
                                 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;opacity:1;height:100vh!important;':'font-family: Comfortaa!important;opacity:1;height:100vh!important;'"
                                 v-for="slider in sliders" :key="slider.slidername">


                                <div class="style__SpotlightItemStyled-vo40go-0 cDscbW" style="height:100vh">
                                    <figure style="height: 100vh;!important">
                                        <div aria-hidden="true" style="width:100%;padding-bottom:100%"></div>
                                        <img v-if="slider.image" :src="serverurl+'/public/sliders/'+slider.image"
                                             alt="Market Equity"
                                             style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100vh!important;object-fit:cover;object-position:center"/>
                                    </figure>

                                    <div class="spotlight__info container" style="background-color:transparent;border:0;paddding-top:10%">
                                        <div class="react-reveal row"
                                             :style="$i18n.locale == 'العربية' ?'float: right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'float: left;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;max-width:100%;'"
                                        >
                                            <div class="style__SectionTitleStyled-d40vxv-0 kcvceY col-sm"
                                                 :style="$i18n.locale == 'العربية' ?'margin-top: 20%!important;text-align:right!important':'margin-top: 20%!important;text-align:left!important'">
                                                <h2 :style="$i18n.locale == 'العربية' ?'max-width:100%;font-family: Cairo,sans-serif !important;':'max-width:100%;font-family: Comfortaa!important'">
                                                    {{
                                                        $i18n.locale == 'en' ? slider.en_title : $i18n.locale == 'العربية' ? slider.ar_title : $i18n.locale == '中文' ? slider.ch_title : $i18n.locale == 'Русский' ? slider.ru_title : slider.fr_title
                                                    }}</h2>


                                                <p :style="$i18n.locale == 'العربية' ?'min-width:500px;margin-top:30px!important;float:right;font-size: 23px!important;text-transform: capitalize!important;font-family: Cairo,sans-serif !important;margin-right:4%':'margin-top:30px!important;float:left;font-size: 23px!important;text-transform: capitalize!important;font-family: Comfortaa!important;margin-left:4%'">

                                                    {{
                                                        $i18n.locale == 'en' ? slider.en_subtitle : $i18n.locale == 'العربية' ? slider.ar_subtitle : $i18n.locale == '中文' ? slider.ch_subtitle : slider.fr_subtitle
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="style__SpotlightThumbs-vo40go-1 lpdeLb col-sm"
                                             :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important':'float: left!important'">

                                        </div>
                                        <div class="btn_wrap"
                                             :style="$i18n.locale == 'العربية' ?'float: right':'float: left'">

                                            <div v-for="slidericon  in slidericons[0].slice(1)" class="react-reveal"
                                                 :key="slidericon.id"
                                                 style="padding-left: 0%;padding-right: 0%;max-width: 200px;margin-top:0px!important;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp">
                                                <div v-if="slider.id==slidericon.sliderid"
                                                     class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                    <figure style="margin-bottom:-9px!important;">
                                                        <a :href="$i18n.locale == 'en' ? '../en/'+slidericon.link : $i18n.locale == 'العربية' ? '../ar/'+slidericon.link : $i18n.locale == '中文' ? '../ch/'+slidericon.link: $i18n.locale=='Русский'?'../ru/'+slidericon.link : '../fr/'+slidericon.link">


                                                            <img v-if="slidericon.image"
                                                                 style="width:56px!important;height:56px!important"
                                                                 :src="serverurl+'/public/icons/'+slidericon.image"></a>
                                                    </figure>
                                                    <div><h3
                                                        :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'">
                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+slidericon.link : $i18n.locale == 'العربية' ? '../ar/'+slidericon.link : $i18n.locale == '中文' ? '../ch/'+slidericon.link: $i18n.locale=='Русский'?'../ru/'+slidericon.link : '../fr/'+slidericon.link">

                                                            {{
                                                                $i18n.locale == 'en' ? slidericon.titleen : $i18n.locale == 'العربية' ? slidericon.titlear : $i18n.locale == '中文' ? slidericon.titlech : $i18n.locale == 'Русский' ? slidericon.titleru : slidericon.titlefr
                                                            }}</a></h3></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="style__SpotlightThumbs-vo40go-1 lpdeLb col-sm"
                                             :style="$i18n.locale == 'العربية' ?'text-transform:uppercase!important;float: right!important':'float: left!important'">

                                        </div>
                                        <div class="btn_wrap"
                                             :style="$i18n.locale == 'العربية' ?'float: right':'float: left'">

                                            <div v-for="sliderbutton  in sliderbuttons[0].slice(1)" class="react-reveal"
                                                 :key="sliderbutton.id"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                                <div
                                                    v-if="slider.id==sliderbutton.sliderid && sliderbutton.firstlinebutton"
                                                    class="style__ButtonWrap-kitu94-0 hqzysg"><a
                                                    :style="sliderbutton.sortorder==1?'text-transform:uppercase!important':'text-transform:uppercase!important'"
                                                    :href="sliderbutton.link" target="_blank"
                                                    rel="noopener noreferrer"><span>
                                                {{

                                                        $i18n.locale == 'en' ? sliderbutton.titleen : $i18n.locale == 'العربية' ? sliderbutton.titlear : $i18n.locale == '中文' ? sliderbutton.titlech : $i18n.locale == 'Русский' ? sliderbutton.titleru : sliderbutton.titlefr
                                                    }}</span></a></div>

                                                <!--                                                {{ $i18n.locale == 'en' ? 'OPEN DEMO ACCOUNT' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي  ' : $i18n.locale == '中文' ? '开设模拟账户' : 'Ouvrir un compte Démo' }}</span></a></div>-->
                                            </div>


                                            <div v-for="sliderbutton  in sliderbuttons[0]" class="react-reveal"
                                                 :key="sliderbutton.id"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                                <div
                                                    v-if="slider.id==sliderbutton.sliderid && !sliderbutton.firstlinebutton"
                                                    class="style__ButtonWrap-kitu94-0 hqzysg"><a
                                                    :style="sliderbutton.sortorder==1?'text-transform:uppercase!important':'text-transform:uppercase!important'"
                                                    :href="sliderbutton.link" target="_blank"
                                                    rel="noopener noreferrer"><span
                                                    :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important;'">
                                                {{

                                                        $i18n.locale == 'en' ? sliderbutton.titleen : $i18n.locale == 'العربية' ? sliderbutton.titlear : $i18n.locale == '中文' ? sliderbutton.titlech : $i18n.locale == 'Русский' ? sliderbutton.titleru : sliderbutton.titlefr
                                                    }}</span></a></div>

                                                <!--                                                {{ $i18n.locale == 'en' ? 'OPEN DEMO ACCOUNT' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي  ' : $i18n.locale == '中文' ? '开设模拟账户' : 'Ouvrir un compte Démo' }}</span></a></div>-->
                                            </div>

                                            <!--                                        <div class="react-reveal"-->
                                            <!--                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 240ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">-->
                                            <!--                                            <div class="style__ButtonWrap-kitu94-0 hqzysg"><a-->
                                            <!--                                                href="https://portal.marketequityinc.com/realaccount" target="_blank"-->
                                            <!--                                                rel="noopener noreferrer"><span>{{ $i18n.locale == 'en' ? 'OPEN LIVE ACCOUNT' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي ' : $i18n.locale == '中文' ? '开设真实账户' : 'Ouvrir un compte Réel' }}</span></a></div>-->
                                            <!--                                        </div>-->
                                        </div>
                                    </div>
                                </div>


                                <div class="bs-slider-overlay"></div>

                            </div>

                        </div>
                        <!-- Left Control -->

                        <a :style="$i18n.locale == 'العربية' ?'right: auto;left: 10px!important;':'left: auto!important;right: 105px!important;'"
                           class="left carousel-control" href="#bootstrap-touch-slider" role="button" data-slide="prev">
                            <span class="fa fa-angle-left" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>

                        <!-- Right Control -->


                        <a :style="$i18n.locale == 'العربية' ?'right: auto;left:100px!important;':'right: 1%!important'"
                           class="right carousel-control" href="#bootstrap-touch-slider" role="button"
                           data-slide="next">
                            <span class="fa fa-angle-right" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>


            <!--
                        <div  class="section section-description" data-section="speciality">
                            &lt;!&ndash; Begin of section wrapper &ndash;&gt;
                            <div class="section-wrapper fullwidth with-margin">

                                <div class="section-content anim">
                                    <div class="style__SectionOurProductStyled-rvkk1m-0 ecoSzV">
                                        <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">
                                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">

                                                <img v-if="this.homeblockimage1" :src="this.serverurl+'/public/homepageblocks/'+this.homeblockimage1"
                                                     alt=""
                                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-position:center;opacity:1;transition-delay:500ms"/>
                                                <picture>

                                                    <img v-if="this.homeblockimage1" loading="lazy" sizes="(max-width: 1600px) 100vw, 1600px"
                                                         :src="this.serverurl+'/public/homepageblocks/'+this.homeblockimage1"
                                                         alt=""
                                                         style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                                </picture>

                                            </div>
                                        </figure>
                                        <div class="style__ColLeft-sc-1jzm2bc-1 kizzFE">
                                            <div class="style__SpecialityItemWrap-sc-1lqx9g2-1 iRUZIk">

                                                <div v-for="homepageblocksicon  in homepageblocksicons" class="react-reveal"
                                                     :key="homepageblocksicon.id"
                                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                                    <div v-if="homepageblocks[0].id==homepageblocksicon.pageblocks_id"
                                                         class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                        <figure>
                                                            <a :href="$i18n.locale == 'en' ? homepageblocksicon.iconlinken : $i18n.locale == 'العربية' ? homepageblocksicon.iconlinkar : $i18n.locale == '中文' ? homepageblocksicon.iconlinkch : $i18n.locale=='Русский'?homepageblocksicon.iconlinkru: homepageblocksicon.iconlinkfr
            ">
                                                                <img v-if="homepageblocksicon.image"
                                                                     :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicon.image"/>

                                                            </a>
                                                        </figure>
                                                        <div>
                                                            <h3>
                                                                <a :href="$i18n.locale == 'en' ? homepageblocksicon.iconlinken : $i18n.locale == 'العربية' ? homepageblocksicon.iconlinkar : $i18n.locale == '中文' ? homepageblocksicon.iconlinkch: $i18n.locale=='Русский'?homepageblocksicon.iconlinkru : homepageblocksicon.iconlinkfr
            ">
                                                                    {{
                                                                    $i18n.locale == 'en' ? homepageblocksicon.icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicon.icon_artitle : $i18n.locale == '中文' ? homepageblocksicon.icon_chtitle: $i18n.locale=='Русский'?homepageblocksicon.icon_rutitle : homepageblocksicon.icon_frtitle
                                                                    }}</a>
                                                            </h3>
                                                            <p>
                                                                {{
                                                                $i18n.locale == 'en' ? homepageblocksicon.subtitleen : $i18n.locale == 'العربية' ? homepageblocksicon.subtitlear : $i18n.locale == '中文' ? homepageblocksicon.subtitlech : homepageblocksicon.subtitlefr
                                                                }}

                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                        <div class="style__ColRight-sc-1jzm2bc-2 cAkZYk">
                                            <div class="style__SecTitleWrap-sc-1lqx9g2-2 cOPQom">
                                                <div class="react-reveal"
                                                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                                    <div class="style__SectionTitleStyled-d40vxv-0 kcvceY">


                                                        <h2 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif!important;':'font-family: Roboto, sans-serif!important'" v-if="homepageblocks[0]">{{
                                                            $i18n.locale == 'en' ? homepageblocks[0]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[0]['titlear'] : $i18n.locale == '中文' ? homepageblocks[0]['titlech']:$i18n.locale=='Русский'?homepageblocks[0]['titleru'] : homepageblocks[0]['titlefr']
                                                            }}</h2>

                                                        <p>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
            -->

            <div class="section section-twoside project-slider" data-section="our-products">
                <div class="section-wrapper fullwidth with-margin">

                    <section class="style__SectionWrapStyled-sc-1jzm2bc-0 llYchI">
                        <div class="style__SectionOurProductStyled-rvkk1m-0 ecoSzV">
                            <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">
                                <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                    <div aria-hidden="true" style="width:100%;padding-bottom:49.5%">
                                    </div>
                                    <img v-if="homepageblocks"
                                         :src="this.serverurl+'/public/homepageblocks/'+this.homepageblocks[1].image"
                                         alt=""
                                         style="position:absolute;top:0;left:0;width:100%;height:100%;object-position:center;transition-delay:500ms"/>
                                    <picture>

                                        <img v-if="homepageblocks" loading="lazy"
                                             sizes="(max-width: 1600px) 100vw, 1600px"
                                             :src="this.serverurl+'/public/homepageblocks/'+this.homepageblocks[1].image"
                                             alt=""
                                             style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-position:center"/>
                                    </picture>

                                </div>
                            </figure>

                            <div class="style__ColLeft-sc-1jzm2bc-1 kizzFE">
                                <div class="style__ProductContentWrap-rvkk1m-2 eUokaU">
                                    <div class="react-reveal"
                                         style="margin-left: 0% !important;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;"
                                         v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский'||  $i18n.locale=='Français'">
                                        <div class="style__SectionTitleStyled-d40vxv-0 kcvceY">
                                            <h1 :style="$i18n.locale=='العربية'?'margin-left: 13%;color:#ffffff;font-family: Cairo,sans-serif !important;text-transform: capitalize !important;':'margin-top:-5%;margin-left: 13%;color:#ffffff;font-family: Comfortaa!important;text-transform: capitalize !important;'"
                                                v-if="homepageblocks">{{
                                                    $i18n.locale == 'en' ? homepageblocks[1]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[1]['titlear'] : $i18n.locale == '中文' ? homepageblocks[1]['titlech'] : $i18n.locale == 'Русский' ? homepageblocks[1]['titleru'] : homepageblocks[1]['titlefr']
                                                }}</h1>
                                        </div>

                                        <div class="style__ListWrap-rvkk1m-3 jXTXRd"
                                             v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский'||  $i18n.locale=='Français'">
                                            <div :v-if="$i18n.locale == 'en'"
                                                 v-for="homepageblocksicon  in homepageblocksicons" class="react-reveal"
                                                 :key="homepageblocksicon.id"
                                                 :style="$i18n.locale == 'العربية' ?'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                                <div v-if="homepageblocks[1].id==homepageblocksicon.pageblocks_id"
                                                     class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                    <figure><a
                                                        :href="$i18n.locale == 'en' ?  '../en/'+homepageblocksicon.iconlink : $i18n.locale == 'العربية' ?  '../ar/'+homepageblocksicon.iconlink : $i18n.locale == '中文' ?  '../ch/'+homepageblocksicon.iconlink:$i18n.locale=='Русский'? '../ru/'+homepageblocksicon.iconlink :  '../fr/'+homepageblocksicon.iconlink
                            "> <img v-if="homepageblocksicon.image" style="width:56px!important;height:56px!important"
                                    :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicon.image"/></a>
                                                    </figure>
                                                    <div><h3>
                                                        <a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
                                                           :href="$i18n.locale == 'en' ?  '../en/'+homepageblocksicon.iconlink : $i18n.locale == 'العربية' ?  '../ar/'+homepageblocksicon.iconlink : $i18n.locale == '中文' ?  '../ch/'+homepageblocksicon.iconlink:$i18n.locale=='Русский'? '../ru/'+homepageblocksicon.iconlink :  '../fr/'+homepageblocksicon.iconlink
                            ">
                                                            {{
                                                                $i18n.locale == 'en' ? homepageblocksicon.icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicon.icon_artitle : $i18n.locale == '中文' ? homepageblocksicon.icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicon.icon_rutitle : homepageblocksicon.icon_frtitle
                                                            }}</a>
                                                    </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-for="blockssecondiconstitledata  in blockssecondiconstitle" class="kcvceY"
                                         :key="blockssecondiconstitledata.id"
                                         :style="$i18n.locale == 'العربية' ?'min-width: 664px;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;text-align:right!important;float:right!important;':'min-width: 664px;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'"
                                         :v-if="$i18n.locale=='العربية'|| $i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский'|| $i18n.locale=='Français'">

                                        <h1 :style="$i18n.locale=='العربية'?'margin-top:-6%;padding-left: 10%!important;line-height: 67px;color:#ffffff;font-family: Cairo,sans-serif !important;text-transform: capitalize !important;float:right':'margin-top:-7%;padding-left:10%;line-height: 67px;color:#ffffff;font-family: Comfortaa!important;text-transform: capitalize !important;'"
                                            v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский' || $i18n.locale=='Français' && homepageblocks[1].id==blockssecondiconstitledata.pageblocks_id">
                                            {{
                                                $i18n.locale == 'en' ? blockssecondiconstitledata.en_title : $i18n.locale == 'العربية' ? blockssecondiconstitledata.ar_title : $i18n.locale == '中文' ? blockssecondiconstitledata.ch_title : $i18n.locale == 'Русский' ? blockssecondiconstitledata.ru_title : blockssecondiconstitledata.fr_title
                                            }}</h1>

                                    </div>
                                    <div class="style__ListWrap-rvkk1m-3 jXTXRd"
                                         v-if="$i18n.locale != 'العربية'">


                                        <div v-for="homepageblockssecondicon  in homepageblockssecondicons"
                                             :key="homepageblockssecondicon.id"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                            <div v-if="homepageblocks[1].id==homepageblockssecondicon.pageblocks_id"
                                                 class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                <figure><a :href="$i18n.locale == 'en' ? '../en/'+homepageblockssecondicon.iconlink : $i18n.locale == 'العربية' ? '../ar/'+homepageblockssecondicon.iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblockssecondicon.iconlink:$i18n.locale=='Русский'?'../ru/'+homepageblockssecondicon.iconlink : '../fr/'+homepageblockssecondicon.iconlink

                            "> <img v-if="homepageblockssecondicon.image"
                                    :src="serverurl+'/public/homepageblockssecondicons/'+homepageblockssecondicon.image"/></a>
                                                </figure>
                                                <div><h3>
                                                    <a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
                                                       :href="$i18n.locale == 'en' ? '../en/'+homepageblockssecondicon.iconlink : $i18n.locale == 'العربية' ? '../ar/'+homepageblockssecondicon.iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblockssecondicon.iconlink:$i18n.locale=='Русский'?'../ru/'+homepageblockssecondicon.iconlink : '../fr/'+homepageblockssecondicon.iconlink
                            ">
                                                        {{
                                                            $i18n.locale == 'en' ? homepageblockssecondicon.icon_entitle : $i18n.locale == 'العربية' ? homepageblockssecondicon.icon_artitle : $i18n.locale == '中文' ? homepageblockssecondicon.icon_chtitle : $i18n.locale == 'Русский' ? homepageblockssecondicon.icon_rutitle : homepageblockssecondicon.icon_frtitle
                                                        }}</a>
                                                </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div class="style__ColRight-sc-1jzm2bc-2 cAkZYk">
                                <div class="style__VideoWrap-sc-1mwsbje-0 Kwidt" v-if="$i18n.locale == 'العربية'">

                                    <div class="style__ProductContentWrap-rvkk1m-2  eUokaU"
                                         v-if="$i18n.locale == 'العربية'">
                                        <div class="react-reveal"
                                             style="margin-top:1%!important;margin-left: 10%;margin-right: -12%;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;"
                                             v-if="$i18n.locale == 'العربية'">
                                            <div class="style__SectionTitleStyled-d40vxv-0 kcvceY">
                                                <h1 :style="$i18n.locale=='العربية'?'margin-right:15%;margin-top:-4%;color:#ffffff;font-family: Cairo,sans-serif !important;text-transform: capitalize !important;':'color:#ffffff;font-family: Comfortaa!important;text-transform: capitalize !important;'"
                                                    v-if="this.homepageblocks">{{
                                                        $i18n.locale == 'en' ? homepageblocks[1]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[1]['titlear'] : $i18n.locale == '中文' ? homepageblocks[1]['titlech'] : $i18n.locale == 'Русский' ? homepageblocks[1]['titleru'] : homepageblocks[1]['titlefr']
                                                    }}

                                                </h1>
                                            </div>

                                            <div class="style__ListWrap-rvkk1m-3 jXTXRd"
                                                 v-if="$i18n.locale == 'العربية'">
                                                <div v-for="homepageblocksicon  in homepageblocksicons"
                                                     class="react-reveal"
                                                     :key="homepageblocksicon.id"
                                                     :style="$i18n.locale == 'العربية' ?'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                                    <div v-if="homepageblocks[1].id==homepageblocksicon.pageblocks_id"
                                                         class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                        <figure><a :href="$i18n.locale == 'en' ? homepageblocksicon.iconlinken : $i18n.locale == 'العربية' ? homepageblocksicon.iconlinkar : $i18n.locale == '中文' ? homepageblocksicon.iconlinkch:$i18n.locale=='Русский'?homepageblocksicon.iconlinkru : homepageblocksicon.iconlinkfr
                            "> <img v-if="homepageblocksicon.image"
                                    :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicon.image"/></a>
                                                        </figure>
                                                        <div><h3>
                                                            <a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
                                                               :href="$i18n.locale == 'en' ? homepageblocksicon.iconlinken : $i18n.locale == 'العربية' ? homepageblocksicon.iconlinkar : $i18n.locale == '中文' ? homepageblocksicon.iconlinkch:$i18n.locale=='Русский'?homepageblocksicon.iconlinkru : homepageblocksicon.iconlinkfr
                            ">
                                                                {{
                                                                    $i18n.locale == 'en' ? homepageblocksicon.icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicon.icon_artitle : $i18n.locale == '中文' ? homepageblocksicon.icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicon.icon_rutitle : homepageblocksicon.icon_frtitle
                                                                }}</a>
                                                        </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-for="blockssecondiconstitledata  in blockssecondiconstitle"
                                             class="kcvceY"
                                             :key="blockssecondiconstitledata.id"
                                             style="min-width: 164px;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                            <h1 :style="$i18n.locale=='العربية'?'margin-left:0%;line-height: 67px;color:#ffffff;font-family: Cairo,sans-serif !important;text-transform: capitalize !important;text-align:left!important':'line-height: 67px;color:#ffffff;font-family: Comfortaa!important;text-transform: capitalize !important;'"
                                                v-if="homepageblocks[1].id==blockssecondiconstitledata.pageblocks_id">{{
                                                    $i18n.locale == 'en' ? blockssecondiconstitledata.en_title : $i18n.locale == 'العربية' ? blockssecondiconstitledata.ar_title : $i18n.locale == '中文' ? blockssecondiconstitledata.ch_title : $i18n.locale == 'Русский' ? blockssecondiconstitledata.ru_title : blockssecondiconstitledata.fr_title
                                                }}</h1>
                                            <p></p>

                                        </div>
                                        <div class="style__ListWrap-rvkk1m-3 jXTXRd" style="margin-top:20%;">


                                            <div v-for="homepageblockssecondicon  in homepageblockssecondicons"
                                                 :key="homepageblockssecondicon.id"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 120ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                                <div v-if="homepageblocks[1].id==homepageblockssecondicon.pageblocks_id"
                                                     class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                    <figure><a :href="$i18n.locale == 'en' ? '../en/'+homepageblockssecondicon.iconlink : $i18n.locale == 'العربية' ? '../ar/'+homepageblockssecondicon.iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblockssecondicon.iconlink:$i18n.locale=='Русский'?'../ru/'+homepageblockssecondicon.iconlink : '../fr/'+homepageblockssecondicon.iconlink
                            "> <img v-if="homepageblockssecondicon.image"
                                    style="margin-top:12%;width:56px!important;height:56px!important"
                                    :src="serverurl+'/public/homepageblockssecondicons/'+homepageblockssecondicon.image"/></a>
                                                    </figure>
                                                    <div><h3>
                                                        <a :style="$i18n.locale == 'العربية' ? 'font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+homepageblockssecondicon.iconlink : $i18n.locale == 'العربية' ? '../ar/'+homepageblockssecondicon.iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblockssecondicon.iconlink:$i18n.locale=='Русский'?'../ru/'+homepageblockssecondicon.iconlink : '../fr/'+homepageblockssecondicon.iconlink
                            ">
                                                            {{
                                                                $i18n.locale == 'en' ? homepageblockssecondicon.icon_entitle : $i18n.locale == 'العربية' ? homepageblockssecondicon.icon_artitle : $i18n.locale == '中文' ? homepageblockssecondicon.icon_chtitle : $i18n.locale == 'Русский' ? homepageblockssecondicon.icon_rutitle : homepageblockssecondicon.icon_frtitle
                                                            }}</a>
                                                    </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>
                    </section>


                </div>

            </div>
            <!-- End of slider section -->

            <!-- Begin of list projects section -->
            <div class="section section-list-feature fp-auto-height-responsive " data-section="market-equity">

                <!-- Begin of section wrapper -->
                <div class="section-wrapper fullwidth with-margin">
                    <!-- content -->
                    <div class="section-content anim">
                        <div class="style__SectionMarketEquityStyled-q939th-0 hcnLuN">
                            <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">

                                <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">

                                    <img v-if="homepageblocks"
                                         :src="this.serverurl+'/public/homepageblocks/'+this.homepageblocks[2].image"
                                         alt=""
                                         style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>

                                    <noscript>
                                        <picture>
                                            <!--                                      <source type='image/webp' srcset="https://marketequity.com/static/5850b7506cb763153ce6ef6a1c1c74dc/1f5c5/home_speciality.webp 400w,-->
                                            <!--https://marketequity.com/static/5850b7506cb763153ce6ef6a1c1c74dc/58556/home_speciality.webp 800w,-->
                                            <!--https://marketequity.com/static/5850b7506cb763153ce6ef6a1c1c74dc/7c22d/home_speciality.webp 1600w"-->
                                            <!--                                              sizes="(max-width: 1600px) 100vw, 1600px"/>-->
                                            <!--                                      <source srcset="this.serverurl+'/public/homepageblocks/'+homepageblocks[0].image 800w,-->
                                            <!--serverurl+'/public/homepageblocks/'+slidericon.image 1600w"-->
                                            <!--                                              sizes="(max-width: 1600px) 100vw, 1600px"/>-->
                                            <img v-if="homepageblocks" loading="lazy"
                                                 sizes="(max-width: 1600px) 100vw, 1600px"
                                                 :src="this.serverurl+'/public/homepageblocks/'+this.homepageblocks[2].image"
                                                 alt=""
                                                 style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                        </picture>
                                    </noscript>
                                </div>
                            </figure>

                            <div class="style__ColLeft-sc-1jzm2bc-1 kizzFE">

                                <div class="style__EquityItemWrap-q939th-1 "
                                     v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский' ||  $i18n.locale=='Français'">

                                    <div>

                                    </div>
                                </div>
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY"
                                     v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский'||  $i18n.locale=='Français'">
                                    <!--                                          <h2>Market Equity</h2>-->

                                    <!--                                          <h5>Partnership Programs</h5>-->
                                </div>
                                <div class="style__EquityItemWrap-q939th-1 "
                                     v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский' ||  $i18n.locale=='Français'">
                                    <div class="style__ProductContentWrap-rvkk1m-2 eUokaU"
                                         v-if="$i18n.locale == 'en' || $i18n.locale == '中文' || $i18n.locale=='Русский'||  $i18n.locale=='Français'">
                                        <div class="style__SectionTitleStyled-d40vxv-0 kcvceY"><h2
                                            :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                            v-if="homepageblocks[2]">{{
                                                $i18n.locale == 'en' ? homepageblocks[2]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[2]['titlear'] : $i18n.locale == '中文' ? homepageblocks[2]['titlech'] : $i18n.locale == 'Русский' ? homepageblocks[2]['titleru'] : homepageblocks[2]['titlefr']
                                            }}</h2></div>
                                    </div>
                                    <div>
                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">

                                            <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                 style="text-align:left!important;">

                                                <figure style="text-align:left!important;">
                                                    <a v-if="this.homepageblocksicons[11]"
                                                       :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[11].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[11].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[11].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[11].iconlink : '../fr/'+homepageblocksicons[11].iconlink">
                                                        <img v-if="this.homepageblocksicons[11].image"
                                                             style="width:56px!important;height:56px!important"
                                                             :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicons[11].image"/>
                                                    </a>
                                                </figure>
                                                <div>
                                                    <h3>
                                                        <a :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[11].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[11].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[11].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[11].iconlink : '../fr/'+homepageblocksicons[11].iconlink"

                                                           v-if="this.homepageblocksicons[11]">
                                                            {{
                                                                $i18n.locale == 'en' ? homepageblocksicons[11].icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicons[11].icon_artitle : $i18n.locale == '中文' ? homepageblocksicons[11].icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicons[11].icon_rutitle : homepageblocksicons[11].icon_frtitle
                                                            }}</a>

                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                            <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                 style="text-align:left!important;">
                                                <figure style="text-align:left!important;">
                                                    <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                                       v-if="this.homepageblocksicons[12]"
                                                       :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[12].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[12].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[12].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[12].iconlink : '../fr/'+homepageblocksicons[12].iconlink">
                                                        <img v-if="this.homepageblocksicons[12].image"
                                                             style="width:56px!important;height:56px!important"
                                                             :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicons[12].image"/>
                                                    </a>
                                                </figure>
                                                <div>
                                                    <h3>
                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[12].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[12].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[12].iconlink : $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[12].iconlink: '../fr/'+homepageblocksicons[12].iconlink"
                                                           v-if="this.homepageblocksicons[12]">{{
                                                                $i18n.locale == 'en' ? homepageblocksicons[12].icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicons[12].icon_artitle : $i18n.locale == '中文' ? homepageblocksicons[12].icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicons[12].icon_rutitle : homepageblocksicons[12].icon_frtitle
                                                            }}</a>

                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                            <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                 style="text-align:left!important;">
                                                <figure style="text-align:left!important;">
                                                    <a v-if="this.homepageblocksicons[13]"
                                                       :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[13].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[13].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[13].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[13].iconlink : '../fr/'+homepageblocksicons[13].iconlink">

                                                        <img v-if="this.homepageblocksicons[13]"
                                                             style="width:56px!important;height:56px!important"
                                                             :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicons[13].image"/>
                                                    </a>
                                                </figure>
                                                <div>
                                                    <h3>
                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[13].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[13].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[13].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[13].iconlink: '../fr/'+homepageblocksicons[13].iconlink"

                                                           v-if="this.homepageblocksicons[13]">{{
                                                                $i18n.locale == 'en' ? homepageblocksicons[13].icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicons[13].icon_artitle : $i18n.locale == '中文' ? homepageblocksicons[13].icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicons[13].icon_rutitle : homepageblocksicons[13].icon_frtitle
                                                            }}</a>

                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div class="style__ColRight-sc-1jzm2bc-2 cAkZYk">
                                <div class="style__EquityItemWrap-q939th-1 " v-if="$i18n.locale == 'العربية'">

                                    <div>

                                    </div>
                                </div>
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" v-if="$i18n.locale == 'العربية'">
                                    <!--                                          <h2>Market Equity</h2>-->

                                    <!--                                          <h5>Partnership Programs</h5>-->
                                </div>
                                <div class="style__EquityItemWrap-q939th-1 " v-if="$i18n.locale == 'العربية'">
                                    <div class="style__ProductContentWrap-rvkk1m-2 eUokaU"
                                         v-if="$i18n.locale == 'العربية'">
                                        <div class="style__SectionTitleStyled-d40vxv-0 kcvceY"><h2
                                            :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                            v-if="homepageblocks[2]">{{
                                                $i18n.locale == 'en' ? homepageblocks[2]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[2]['titlear'] : $i18n.locale == '中文' ? homepageblocks[2]['titlech'] : $i18n.locale == 'Русский' ? homepageblocks[2]['titleru'] : homepageblocks[2]['titlefr']
                                            }}</h2></div>
                                    </div>
                                    <div>
                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;"
                                             v-if="$i18n.locale == 'العربية'">

                                            <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                 style="text-align:left!important;">

                                                <figure style="text-align:left!important;">
                                                    <a v-if="this.homepageblocksicons[11]"
                                                       :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[11].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[11].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[11].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[11].iconlink : '../fr/'+homepageblocksicons[11].iconlink">
                                                        <img v-if="this.homepageblocksicons[11].image"
                                                             style="width:56px!important;height:56px!important"
                                                             :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicons[11].image"/>
                                                    </a>
                                                </figure>
                                                <div>
                                                    <h3>
                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[11].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[11].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[11].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[11].iconlink : '../fr/'+homepageblocksicons[11].iconlink"

                                                           v-if="this.homepageblocksicons[11]">
                                                            {{
                                                                $i18n.locale == 'en' ? homepageblocksicons[11].icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicons[11].icon_artitle : $i18n.locale == '中文' ? homepageblocksicons[11].icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicons[11].icon_rutitle : homepageblocksicons[11].icon_frtitle
                                                            }}</a>

                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                            <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                 style="text-align:left!important;">
                                                <figure style="text-align:left!important;">
                                                    <a v-if="this.homepageblocksicons[12]"
                                                       :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[12].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[12].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[12].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[12].iconlink : '../fr/'+homepageblocksicons[12].iconlink">
                                                        <img v-if="this.homepageblocksicons[12].image"
                                                             style="width:56px!important;height:56px!important"
                                                             :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicons[12].image"/>
                                                    </a>
                                                </figure>
                                                <div>
                                                    <h3>
                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[12].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[12].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[12].iconlink : $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[12].iconlink: '../fr/'+homepageblocksicons[12].iconlink"
                                                           v-if="this.homepageblocksicons[12]">{{
                                                                $i18n.locale == 'en' ? homepageblocksicons[12].icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicons[12].icon_artitle : $i18n.locale == '中文' ? homepageblocksicons[12].icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicons[12].icon_rutitle : homepageblocksicons[12].icon_frtitle
                                                            }}</a>

                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                            <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj"
                                                 style="text-align:left!important;">
                                                <figure style="text-align:left!important;">
                                                    <a v-if="this.homepageblocksicons[13]"
                                                       :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[13].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[13].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[13].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[13].iconlink : '../fr/'+homepageblocksicons[13].iconlink">

                                                        <img v-if="this.homepageblocksicons[14]"
                                                             style="width:56px!important;height:56px!important"
                                                             :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicons[14].image"/>
                                                    </a>
                                                </figure>
                                                <div>
                                                    <h3>
                                                        <a :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;color:#ffffff;text-transform: capitalize !important;':'font-family: Comfortaa!important;color:#ffffff;text-transform: capitalize !important;'"
                                                           :href="$i18n.locale == 'en' ? '../en/'+this.homepageblocksicons[13].iconlink: $i18n.locale == 'العربية' ? '../ar/'+homepageblocksicons[13].iconlink : $i18n.locale == '中文' ? '../ch/'+homepageblocksicons[13].iconlink: $i18n.locale=='Русский'?'../ru/'+homepageblocksicons[13].iconlink: '../fr/'+homepageblocksicons[13].iconlink"

                                                           v-if="this.homepageblocksicons[13]">{{
                                                                $i18n.locale == 'en' ? homepageblocksicons[13].icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicons[13].icon_artitle : $i18n.locale == '中文' ? homepageblocksicons[13].icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicons[13].icon_rutitle : homepageblocksicons[13].icon_frtitle
                                                            }}</a>

                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <!-- End of section wrapper -->
            </div>
            <!-- End of list projects section -->

            <!-- Begin of list feature section -->
            <!--
                        <div class="section section-list-feature fp-auto-height-responsive " data-section="research">
                            &lt;!&ndash; section cover &ndash;&gt;
                            <div class="section-cover-full bg-img" data-image-src="./img/sections/services.png">
                            </div>

                            &lt;!&ndash; Begin of section wrapper &ndash;&gt;
                            <div class="section-wrapper fullwidth with-margin">
                                &lt;!&ndash; content &ndash;&gt;
                                <div class="style__SectionResearchStyled-sc-1su9cn9-0 fKfecE">
                                    <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">
                                        <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">

                                            <img aria-hidden="true"
                                                 v-if="this.homepageblocks" loading="lazy"
                                                 sizes="(max-width: 1600px) 100vw, 1600px"
                                                 :src="this.serverurl+'/public/homepageblocks/'+this.homepageblocks[3].image"
                                                 alt=""
                                                 style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                            <noscript>
                                                <picture>

                                                    <img loading="lazy" sizes="(max-width: 1600px) 100vw, 1600px"
                                                         v-if="this.homepageblocks"
                                                         :src="this.serverurl+'/public/homepageblocks/'+this.homepageblocks[3].image"
                                                         alt=""
                                                         style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                                </picture>
                                            </noscript>
                                        </div>
                                    </figure>
                                    <div class="style__ColLeft-sc-1jzm2bc-1 kizzFE">


                                        <div class="react-reveal"
                                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                            <div class="style__TitleWrap-sc-1su9cn9-1 kmpBnC">
                                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" style="border-bottom: 0px!important;">
                                                    <h2 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif!important;width: 100%;border:0!important;':'font-family: Roboto, sans-serif!important;width: 100%;border:0!important;'" v-if="homepageblocks">                                        {{
                                                            $i18n.locale == 'en' ? homepageblocks[3]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[3]['titlear'] : $i18n.locale == '中文' ? homepageblocks[3]['titlech']  : $i18n.locale == 'Русский' ? homepageblocks[3]['titleru']: homepageblocks[3]['titlefr']
                                                        }}</h2>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="style__ColRight-sc-1jzm2bc-2 cAkZYk">
                                        <div class="style__ResearchItemWrap-sc-1su9cn9-2 ppySe">
                                            <div v-for="homepageblocksicon  in homepageblocksicons" class="react-reveal"
                                                 :key="homepageblocksicon.id"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;"
                                            >
                                                <div v-if="homepageblocks[3].id==homepageblocksicon.pageblocks_id"
                                                     class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                    <figure :style="$i18n.locale=='العربية'?'float:right;margin-left:2%':'float:left'">
                                                        <img
                                                            :src="serverurl+'/public/homepageblocksicons/'+homepageblocksicon.image"/>
                                                    </figure>
                                                    <div :style="$i18n.locale=='العربية'?'text-align:right':'text-align:left'">
                                                        <h3 :style="$i18n.locale=='العربية'?'text-align:right':'text-align:left'">

                                                            &lt;!&ndash;                    <a :href="$i18n.locale == 'en' ?'../' .homepageblocksicon.iconlinken : $i18n.locale == 'العربية' ? '../' .homepageblocksicon.iconlinkar : $i18n.locale == '中文' ? '../' .homepageblocksicon.iconlinkch : '../' .homepageblocksicon.iconlinkfr&ndash;&gt;
                                                            &lt;!&ndash;                                                       ">&ndash;&gt;

                                                            {{
                                                                $i18n.locale == 'en' ? homepageblocksicon.icon_entitle : $i18n.locale == 'العربية' ? homepageblocksicon.icon_artitle : $i18n.locale == '中文' ? homepageblocksicon.icon_chtitle : $i18n.locale == 'Русский' ? homepageblocksicon.icon_rutitle : homepageblocksicon.icon_frtitle
                                                            }}
                                                            &lt;!&ndash; </a>&ndash;&gt;
                                                        </h3>
                                                        <p>
                                                            {{
                                                                $i18n.locale == 'en' ? homepageblocksicon.subtitleen : $i18n.locale == 'العربية' ? homepageblocksicon.subtitlear : $i18n.locale == '中文' ? homepageblocksicon.subtitlech: $i18n.locale == 'Русский' ? homepageblocksicon.subtitleru : homepageblocksicon.subtitlefr
                                                            }}

                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                                &lt;!&ndash; Arrows scroll down/up &ndash;&gt;

                            </div>
                            &lt;!&ndash; End of section wrapper &ndash;&gt;
                        </div>
            -->
            <!-- End of list feature section -->


            <!-- Begin of list products section -->
            <!--            <div class="section section-grid fp-auto-height-responsive " data-section="CEO-Message">-->
            <!--              -->
            <!--                <div class="section-wrapper fullwidth ">-->
            <!--                    <div class="style__CEOMessageStyled-qd9971-0 kzoXLm">-->
            <!--                        <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">-->
            <!--                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">-->

            <!--                                <img v-if="this.homepageblocks" aria-hidden="true"-->
            <!--                                     :src="serverurl+'/public/homepageblocks/'+homepageblocks[4].image" alt=""-->
            <!--                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>-->
            <!--                                <img v-if="this.homepageblocks"-->
            <!--                                     :src="serverurl+'/public/homepageblocks/'+homepageblocks[4].image"-->
            <!--                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>-->
            <!--                                />-->

            <!--                    <noscript>-->
            <!--                        <picture>-->
            <!--                                      <source type='image/webp' srcset="https://marketequity.com/static/37bb868f70d47d1b5928a89ea01b22b8/1f5c5/ceo-message.webp 400w,-->
            <!--		https://marketequity.com/static/37bb868f70d47d1b5928a89ea01b22b8/58556/ceo-message.webp 800w,-->
            <!--		https://marketequity.com/static/37bb868f70d47d1b5928a89ea01b22b8/7c22d/ceo-message.webp 1600w"-->
            <!--                                              sizes="(max-width: 1600px) 100vw, 1600px"/>-->
            <!--                                      <source srcset="https://marketequity.com/static/37bb868f70d47d1b5928a89ea01b22b8/2244e/ceo-message.jpg 400w,-->
            <!--		https://marketequity.com/static/37bb868f70d47d1b5928a89ea01b22b8/14b42/ceo-message.jpg 800w,-->
            <!--		https://marketequity.com/static/37bb868f70d47d1b5928a89ea01b22b8/0e329/ceo-message.jpg 1600w"-->
            <!--                                              sizes="(max-width: 1600px) 100vw, 1600px"/>-->
            <!--                            <img v-if="this.homepageblocks" loading="lazy"-->
            <!--                                 sizes="(max-width: 1600px) 100vw, 1600px"-->
            <!--                                 :src="serverurl+'/public/homepageblocks/'+homepageblocks[4].image"-->
            <!--                                 alt=""-->
            <!--                                 style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
            <!--                        </picture>-->
            <!--                    </noscript>-->
            <!--                </div>-->
            <!--            </figure>-->
            <!--            <div class="style__CeoMessageMain-qd9971-4 bbJFLO">-->
            <!--                <div class="style__TitleWrap-qd9971-1 hNxSIC">-->
            <!--                    <h2 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'" v-if="this.homepageblocks">{{-->
            <!--                            $i18n.locale == 'en' ? homepageblocks[4]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[4]['titlear'] : $i18n.locale == '中文' ? homepageblocks[4]['titlech']  : $i18n.locale == 'Русский' ? homepageblocks[4]['titleru']: homepageblocks[4]['titlefr']-->
            <!--                        }}</h2>-->
            <!--                </div>-->
            <!--                <div class="react-reveal"-->
            <!--                     style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">-->
            <!--                    <div class="style__CeoMessageWrap-qd9971-2 caMZCv">-->
            <!--                        <div class="style__CeoImageWrap-qd9971-3 ccOGDp" :style="$i18n.locale == 'العربية' ?'float:right':'float:left'">-->
            <!--                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">-->

            <!--                                <img v-if="ceomessage.image" aria-hidden="true"-->
            <!--                                     :src="serverurl+ceomessage.image"-->
            <!--                                     alt=""-->
            <!--                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>-->
            <!--                                <noscript>-->
            <!--                                    <picture>-->

            <!--                                        <img v-if="ceomessage.image" loading="lazy" sizes="(max-width: 374px) 100vw, 374px"-->
            <!--                                             srcset=""-->
            <!--                                             :src="serverurl+ceomessage.image"-->
            <!--                                             alt=""-->
            <!--                                             style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>-->
            <!--                                    </picture>-->
            <!--                                </noscript>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                        <div  dir="rtl" :class="$i18n.locale == 'العربية' ?'contScroll1':'contScroll'" :style="$i18n.locale == 'العربية' ?'text-align:right;font-size:14px;line-height: 20px;':'text-align:left;font-size:14px;line-height: 20px;'"-->
            <!--                                          v-html="$i18n.locale=='en'?ceomessage.contenten:$i18n.locale=='العربية'?ceomessage.contentar:$i18n.locale=='中文'?ceomessage.contentch: $i18n.locale == 'Русский' ? ceomessage.contentru:ceomessage.contentfr">-->
            <!--                            {{-->
            <!--                                $i18n.locale == 'en' ? ceomessage.contenten : $i18n.locale == 'العربية' ? ceomessage.contentar : $i18n.locale == '中文' ? ceomessage.contentch: $i18n.locale == 'Русский' ? ceomessage.contentru : ceomessage.contentfr-->
            <!--                            }}-->

            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--        </div>-->
            <!--    </div>-->
            <!--            </div>-->
            <!-- End of list products section -->


            <div class="section section-grid fp-auto-height-responsive " data-section="Core-Values">

                <div class="section-wrapper fullwidth ">
                    <div class="style__CEOMessageStyled-qd9971-0 kzoXLm">
                        <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">

                                <img v-if="this.homepageblocks" aria-hidden="true"
                                     :src="serverurl+'/public/homepageblocks/'+homepageblocks[4].image" alt=""
                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                <img v-if="this.homepageblocks"
                                     :src="serverurl+'/public/homepageblocks/'+homepageblocks[4].image"
                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                />

                                <noscript>
                                    <picture>

                                        <img v-if="this.homepageblocks" loading="lazy"
                                             sizes="(max-width: 1600px) 100vw, 1600px"
                                             :src="serverurl+'/public/homepageblocks/'+homepageblocks[4].image"
                                             alt=""
                                             style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                    </picture>
                                </noscript>
                            </div>
                        </figure>
                        <div class="style__CeoMessageMain-qd9971-4 bbJFLO">
                            <div class="style__TitleWrap-qd9971-1 hNxSIC">
                                <h2 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif !important;':'font-family: Comfortaa!important'"
                                    v-if="this.homepageblocks">{{
                                        $i18n.locale == 'en' ? homepageblocks[4]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[4]['titlear'] : $i18n.locale == '中文' ? homepageblocks[4]['titlech'] : $i18n.locale == 'Русский' ? homepageblocks[4]['titleru'] : homepageblocks[4]['titlefr']
                                    }}</h2>
                            </div>
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__CeoMessageWrap-qd9971-2 caMZCv">

                                    <div dir="rtl" :class="$i18n.locale == 'العربية' ?'rtlclass':'ltrclass'"
                                         :style="$i18n.locale == 'العربية' ?'text-align:right;font-size:14px;line-height: 20px;':'text-align:left;font-size:14px;line-height: 20px;'"
                                         v-html="$i18n.locale=='en'?corevalues.contenten:$i18n.locale=='العربية'?corevalues.contentar:$i18n.locale=='中文'?corevalues.contentch: $i18n.locale == 'Русский' ? corevalues.contentru:corevalues.contentfr">
                                        {{
                                            $i18n.locale == 'en' ? corevalues.contenten : $i18n.locale == 'العربية' ? corevalues.contentar : $i18n.locale == '中文' ? corevalues.contentch : $i18n.locale == 'Русский' ? corevalues.contentru : corevalues.contentfr
                                        }}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Begin of register/login/signin section -->
            <!--
                        <div class="section section-register fp-auto-height-responsive " data-section="testimonials">
                            &lt;!&ndash; section cover &ndash;&gt;
                            <div class="section-cover-full bg-img">
                            </div>

                            &lt;!&ndash; Begin of section wrapper &ndash;&gt;
                            <div class="section-wrapper fullwidth ">

                                <div class="style__TestimonialAreaStyled-sc-1ke2p09-0 gigdQa">
                                    <figure class="FrameWork__BackgroudFigure-v8gq48-12 iNtcdO">
                                        <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">

                                            <img v-if="this.homepageblocks" aria-hidden="true"
                                                 :src="serverurl+'/public/homepageblocks/'+homepageblocks[5].image"
                                                 alt=""
                                                 style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                            <noscript>
                                                <picture>

                                                    <img v-if="this.homepageblocks" loading="lazy"
                                                         sizes="(max-width: 1600px) 100vw, 1600px" srcset=""
                                                         :src="serverurl+'/public/homepageblocks/'+homepageblocks[5].image"
                                                         alt=""
                                                         style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                                </picture>
                                            </noscript>
                                        </div>
                                    </figure>
                                    <div class="style__ColLeft-sc-1jzm2bc-1 kizzFE">
                                        <div class="style__TestimonialItemWrap-sc-1ke2p09-2 kyouHE">
                                            <div class="react-reveal"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                                <div class="slick-slider slick-initialized">
                                                    <div class="slick-list">
                                                        <div class="slick-track" style="width:100%;left:0%">
                                                            <div v-for="successstory  in successstories" :key="successstory.id"
                                                                 data-index="0" class="slick-slide slick-active slick-current"
                                                                 tabindex="-1"
                                                                 aria-hidden="false" style="outline:none;min-width:310px">
                                                                <div>
                                                                    <div class="style__ThumbListItemStyled-w7lz1s-0 lcaeBj">
                                                                        <figure>
                                                                            <div class=" gatsby-image-wrapper"
                                                                                 style="position:relative;overflow:hidden;display:inline-block;width:160px;height:160px">
                                                                                <img v-if="successstory.image" aria-hidden="true"
                                                                                     :src="serverurl+'/public/successstories/'+successstory.image"
                                                                                     alt=""
                                                                                     style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;object-position:center;opacity:1;transition-delay:500ms"/>
                                                                                <noscript>
                                                                                    <picture>

                                                                                        <img v-if="successstory.image" loading="lazy" width="160" height="160"

                                                                                             :src="serverurl+'/public/successstories/'+successstory.image"

                                                                                             alt=""
                                                                                             style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                                                                    </picture>
                                                                                </noscript>
                                                                            </div>
                                                                        </figure>
                                                                        <div>


                                                                            <p :style="$i18n.locale == 'العربية' ?'margin-left:20%;padding-right:-5%':'margin-right:20%;padding-left:-5%;'">{{
                                                                                    $i18n.locale == 'en' ? successstory.contenten : $i18n.locale == 'العربية' ? successstory.contentar : $i18n.locale == '中文' ? successstory.contentch: $i18n.locale == 'Русский' ? successstory.contentru : successstory.contentfr
                                                                                }}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="style__ColRight-sc-1jzm2bc-2 cAkZYk">
                                        <div class="style__TitleWrap-sc-1ke2p09-1 hDhxYg">
                                            <div class="react-reveal"
                                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY">
                                                    <h2 :style="$i18n.locale=='العربية'?'font-family: Cairo,sans-serif!important;':'font-family: Roboto, sans-serif!important'" v-if="this.homepageblocks">{{
                                                            $i18n.locale == 'en' ? homepageblocks[5]['titleen'] : $i18n.locale == 'العربية' ? homepageblocks[5]['titlear'] : $i18n.locale == '中文' ? homepageblocks[5]['titlech']: $i18n.locale == 'Русский' ? homepageblocks[5]['titleru'] : homepageblocks[5]['titlefr']
                                                        }}</h2>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>
            -->            <!-- End of register/login/signin section -->

            <!-- Begin of contact section -->
            <div class="section section-contact fp-auto-height-responsive no-slide-arrows " data-section="footer-menu">
                <!-- section cover -->


                <!-- Begin of slide section wrapper -->

                <!-- End of slide section wrapper -->
                <Footer/>
            </div>


            <!-- End of contact section -->
            <iframe style="display: none; position: fixed; border: 0px none; overflow: hidden;"
                    src="https://marketequity.ladesk.com/scripts/generateWidget.php?v=5.21.17.15&amp;t=1607084151&amp;cwid=e00b30c6&amp;cwrt=C&amp;cwt=chat&amp;pt=Home%20page%20-%20Market%20Equity%20Inc%20-%20Leading%20Trading%20Service%20Provider&amp;ref=https%3A%2F%2Fmarketequity.com%2Fen%2F%23speciality"
                    allowfullscreen="true" allow="microphone; camera" tabindex="-1" class="i-embedded-chat"
                    id="icb_e00b30c6_305"></iframe>

        </main>


    </div>

</template>
<!--<script>-->
<!--import "http://localhost/laravelvue/frontend/src/assets/css/bootstrap-touch-slider.css" ;-->
<!--import "http://localhost/laravelvue/frontend/src/assets/css/main.css" ;-->
<!--import 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js';-->
<!--import 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/js/bootstrap.min.js';-->
<!--import 'https://cdnjs.cloudflare.com/ajax/libs/jquery.touchswipe/1.6.18/jquery.touchSwipe.min.js';-->

<!--</script>-->
<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'Home',
    title: 'Home',
    data() {
        return {
            langs: ['en', 'العربية', '中文', 'Français'],
            sliders: [],
            slidericons: [],
            sliderbuttons: [],
            slidetitle1en: null,
            slidetitle1ar: null,
            slidericonsactive: [],
            sliderbuttonsactive: [],
            slidetitle1ch: null,
            slidetitle1fr: null,
            slidetitle1ru: null,
            slidesubtitle1en: null,
            slidesubtitle1ar: null,
            slidesubtitle1ch: null,
            slidesubtitle1fr: null,
            slidesubtitle1ru: null,


            homepageblocks: '',
            homeblock1: null,
            homeblockimage1: null,
            homepageblocksicons: [],
            homepageblocksicons3: [],
            homepageblocks2: '',
            corevalues: '',
            successstories: '',
            prevvideoregister: '',
            isHidden: false,
            name: '',
            email: '',
            acnumber: '',
            message: '',
            emailnotify: null,
            registermobile: '',
            registererror: null,
            successregiter: null,
            userexists: false,
            cardtypeval: null,
            gifshow: false,
            nameError: false,
            emailError: false,
            phoneError: false,
            acnumberError: false,
            cardmodalshow: false,
            userexistsno:false,
            telcode:null,

        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {


    },
    mounted() {
        this.loadhomesliderdata();
        this.loadhomepageblocks();
        this.loadcorevalues();
        this.loadsuccessstories();
        this.loadsocialmedia();
        let addScript = document.createElement('script')
        addScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/js/bootstrap.min.js')
        document.head.appendChild(addScript);
        this.getCode();
    },

    methods: {
        getCode() {
            this.$axios.get('https://ipapi.co/country_calling_code/')
                .then(({data}) => {
                    this.telcode = data;
                   // alert(this.telcode)// update the default
                })
                .catch(err => console.error(err))
            ;
        },
        modalshow() {

            this.cardmodalshow = true;

            //document.getElementById('chinesechat').style.visibility="hidden";
            document.getElementById("arabicchat").style.display="none";
            document.getElementById("englishchat").style.display="none";

        },
        modalhide() {
            this.cardmodalshow = false;
            document.getElementById("arabicchat").style.display="block";
            document.getElementById("englishchat").style.display="block";
        },
        loadhomesliderdata() {

            this.$axios.get("loadhomesliderdata",
            )
                .then(res => {
                    if (res) {

                        this.sliders = res.data.sliders;
                        this.slidetitle1en = res.data.sliders[0].en_title;
                        this.slidetitle1ar = res.data.sliders[0].ar_title;
                        this.slidetitle1ch = res.data.sliders[0].ch_title;
                        this.slidetitle1fr = res.data.sliders[0].fr_title;
                        this.slidetitle1ru = res.data.sliders[0].ru_title;
                        this.slidesubtitle1en = res.data.sliders[0].en_subtitle;
                        this.slidesubtitle1ar = res.data.sliders[0].ar_subtitle;
                        this.slidesubtitle1ch = res.data.sliders[0].ch_subtitle;
                        this.slidesubtitle1fr = res.data.sliders[0].fr_subtitle;
                        this.slidesubtitle1ru = res.data.sliders[0].ru_subtitle;

                        this.slide1image = res.data.sliders[0].image;
                        this.slider1id = res.data.sliders[0].id;

                        this.slidericons = res.data.slidericons;
                        this.slidericonsactive = this.slidericons[0];

                        this.sliderbuttons = res.data.sliderbuttons;
                        this.sliderbuttonsactive = res.data.sliderbuttons[0];


                    }
                });
        },
        loadhomepageblocks() {

            this.$axios.get("loadhomepageblocks",
            )
                .then(res => {
                    if (res) {

                        this.homepageblocks = res.data.homepageblocks;
                        this.homepageblocks2 = res.data.homepageblocks[2].id;
                        this.homeblock1 = res.data.homepageblocks[0].image;
                        this.homeblockimage1 = res.data.homepageblocks[0].image;
                        this.homepageblocksicons = res.data.blocksicons[0];
                        this.homepageblocksicons3 = this.homepageblocksicons[2];
                        this.homepageblockssecondicons = res.data.blockssecondicons[0];
                        this.blockssecondiconstitle = res.data.blockssecondiconstitle[0];
                    }
                });
        },
        loadcorevalues() {

            this.$axios.get("loadcorevalues",
            )
                .then(res => {
                    if (res) {

                        this.corevalues = res.data.corevalues[0];

                    }
                });
        },
        loadsuccessstories() {

            this.$axios.get("loadsuccessstories",
            )
                .then(res => {
                    if (res) {

                        this.successstories = res.data.successstories;

                    }
                });
        },
        loadsocialmedia() {

            this.$axios.get("loadsuccessstories",
            )
                .then(res => {
                    if (res) {

                        this.successstories = res.data.successstories;

                    }
                });
        },
        mouseover() {
            this.gifshow = true
        },
        gifclose() {
            this.gifshow = false;
        },
        // mouseleave(){
        //     this.gifshow = false
        // },
        cardtype(cardval) {
            this.cardtypeval = cardval;
            //const button = document.getElementById('myButton');
           if(cardval==1) {
               document.getElementById('debit').style.background='#14859c';

               document.getElementById('virtual').style.backgroundColor='grey';

               document.getElementById('both').style.background='#14859c';

           }
            if(cardval==2) {
                document.getElementById('virtual').style.background='#14859c';

                document.getElementById('debit').style.background='grey';
                document.getElementById('both').style.background='#14859c';

            }
            if(cardval==3) {
                document.getElementById('virtual').style.background='#14859c';

                document.getElementById('debit').style.background='#14859c';

                document.getElementById('both').style.background='grey';
            }
        },

        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        validatephone(phone) {
            var re = /^\d+$/;
            return re.test(phone);
        },
        changevalue() {
            this.userexists = true;
        },
        changevalueno() {
            this.userexists = false;
        },
        registergatetopay(lan) {

//return false;
if(lan=="العربية" ){
    lan='ar';
}
else{ lan='en';}
            this.nameError = false;
            this.emailError = false;
            this.phoneError = false;
            this.acnumberError = false;

            this.registererror = null;
            this.successregiter = null;
            if (!this.registername) this.nameError = true;
            if (!this.registeremail) this.emailError = true;
            if (!this.registermobile) this.phoneError = true;
            if(!this.userexistsno && !this.userexists){
                if(lan=='ar')
                this.registererror = "الرجاء تعبئة جميع البيانات";
                else
                    this.registererror = "Please fill in all the information.";

                return false;
            }

            if (this.userexists) {
                if (!this.acnumber) this.acnumberError = true;


                if (!this.cardtypeval) {
                    if(lan=='ar')
                        this.registererror = "الرجاء تعبئة جميع البيانات";
                    else
                        this.registererror = "Please fill in all the information.";

                    return false;

                }
                if (!this.registeremail || !this.registermobile || !this.registername || !this.acnumber) {
                    if(lan=='ar')
                        this.registererror = "الرجاء تعبئة جميع البيانات";
                    else
                        this.registererror = "Please fill in all the information.";

                    return false;
                }
            }
            if (!this.userexists) {
                if (!this.registeremail || !this.registermobile || !this.registername) {
                    if(lan=='ar')
                        this.registererror = "الرجاء تعبئة جميع البيانات";
                    else
                        this.registererror = "Please fill in all the information.";
                    return false;
                } else {
                    this.cardtypeval = "Not an Existing User";
                    this.acnumber = "Not an Existing User"
                }
            }

            if (!this.validatephone(this.registermobile)) {
                if(lan=='ar')
                    this.registererror = "الرجاء تعبئة جميع البيانات";
                else
                    this.registererror = "Please fill in all the information.";

                return false;
            }
            if (!this.validateEmail(this.registeremail)) {
                if(lan=='ar')
                    this.registererror = "الرجاء تعبئة جميع البيانات";
                else
                    this.registererror = "Please fill in all the information.";
                return false;
            }
// Make a request to ipinfo.io to get the IP address


// alert(this.langchange)
            this.$axios.get("https://marketequity.com/custommail/gmail/gatetopayemail.php", {
                params: {

                    email: this.registeremail,
                    name: this.registername,
                    acnumber: this.acnumber,
                    mobile: this.registermobile,
                    cardtype: this.cardtypeval,
                    userexists: this.userexists,
                    telcode:this.telcode,
                    language:lan


                }
            })
                .then(response => {
                    if (response) {
                       //  alert(response);
                        console.log(response)

                        if (response == "Duplicate") {
                          //  alert("Duplicate");


                        } else {
                            this.errorregiter = "Error with Register. Please Register after some time";
                            this.webinarpageregisterflag = false;

                        }


                    }
                });
            if(lan=='ar'){
                this.successregiter =" سيتم التواصل معك من قبل موظفينا المتخصصين في أقرب وقت ممكن ";}
                else
            {this.successregiter = "Thank you for requesting your Market Equity Prepaid Master Card  ";}
            this.registeremail = null;
            this.registername = null;
            this.acnumber = null;
            this.registermobile = null;
            //this.successregiter = null;

        },

    }
}
</script>
<style>
.modal-body {
    max-height: calc(100vh - 80px);
    overflow-y: auto;
}

.lpdeLb > div h3 {

    text-transform: uppercase !important;
    font-size: 19px !important;

}

.lcaeBj h3 a {

    text-transform: uppercase !important;
}

.kcvceY h2 {
    text-transform: uppercase !important;
}

.carousel-control {
    position: absolute;
    top: 50%; /* pushes the icon in the middle of the height */
    z-index: 5;
    display: inline-block;
}

.rtlclass {
    direction: rtl !important;


}

.rtlclass h3 {
    direction: rtl !important;
    font-family: Cairo, sans-serif !important;

}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

.fp-responsive .fp-auto-height-responsive .fp-slide, .fp-responsive .fp-auto-height-responsive .fp-tableCell, .fp-responsive .fp-auto-height-responsive.fp-section {
    min-height: 100vh !important;
}

.carousel-inner {
    height: 100vh !important;
    overflow: visible;
}

.bs-slider .bs-slider-overlay {
    background-color: transparent !important;
}

.section {
    padding_top: 0px !important;
    padding-bottom: 0px !important;
}

@media (min-width: 600px) {
    .cDscbW .spotlight__info h2 {
        font-size: 32px;
        line-height: 34px;
        margin: 0;
    }
}

/*!sc*/
@media (min-width: 768px) {
    .cDscbW .spotlight__info h2 {
        font-size: 45px;
        line-height: 46px;
    }
}

/*!sc*/
@media (min-width: 992px) {
    .cDscbW .spotlight__info h2 {
        font-size: 61px;
        line-height: 62px;
    }
}

/*!sc*/
@media (min-width: 1280px) {
    .cDscbW .spotlight__info h2 {
        font-size: 74px;
        line-height: 75px;
    }
}

/*!sc*/

.cDscbW .spotlight__info {
    min-width: 90%;
}

.caMZCv .contScroll1 {
    display: table-cell;
    height: auto;
    overflow: visible;
    text-align: right;
}

.caMZCv .contScroll1 ::before {
    content: " ";
    position: absolute;
    width: 17px;
    height: 17px;
    background: rgba(0, 0, 0, 0) url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE1MUU4MTNEN0YwODExRUE5NzJGOEZCMzYyNEQxRDY2IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE1MUU4MTNFN0YwODExRUE5NzJGOEZCMzYyNEQxRDY2Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTUxRTgxM0I3RjA4MTFFQTk3MkY4RkIzNjI0RDFENjYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTUxRTgxM0M3RjA4MTFFQTk3MkY4RkIzNjI0RDFENjYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz56CBqpAAABjUlEQVR42uzVv0vDQBQH8Ca0IIi0alXoUEUc7CiCi7i4uDv4fzi4ODs4Oro5uTm5uVjFSaUuHSw6aBERKdQfrcYfref3yUUf11zyOmTzwSeh1/fukstd4iilEnGGG/JfP4zrszQGdU36t4XugMnCOlypv3iHvJHH5WADbllNAzI/s8MSF+BBBcespfMlaFpqJvkA8/Ch7DEd0PkifIXUjFFeErPUC9uQYnPpwT5U4AbOjLkegi1wWFsDinABl3DtP4NlY+QKFELmnKwZNSX/ik10OGKJLZiK6Jycs5pXmLDl0qHOksuCzpPQZjUHYfm0DzJsHquCtZ429k81aqPxBzUD+YgBHOP3HAxbk1Xnu6INz8bq2IMVeIIs1Iyals7z4xF2YTWh5LHDdrs0NoPuwBaf0KfVhDV1t4sXWUp33k0MuImY438A0QCeMJdW25smXXkeDXAoTD6FplYS1hRp44zCScSGKftfKK2g28LimD61DttnI/rj03GbcGe5whz0BLS/wL3/Lor1IX8LMAAnvdvo3rhV/wAAAABJRU5ErkJggg==") no-repeat scroll left top / contain;
    right: 16% !important;
    top: 7px;
    transform: rotate(180deg);
}

.lpdeLb > div h3 {
    font-size: 15px !important;
}

.lcaeBj figure img {
    min-width: 58px !important;

    min-height: 58px !important;
}

.lcaeBj h3 {
    font-size: 14px !important;
}

.lcaeBj {
    padding-left: 5px !important;
    padding-right: 5px !important;
    text-align: center !important;
}

/*@media screen and (max-device-width: 480px) {*/
/*  div#modalworldcup {*/
/*    min-width: 90%!important;*/
/*        max-width: 90%!important;*/

/*  }*/
/*}*/
button:focus {
    background: grey;
    font-family: comfortaa, sans-serif;
}
</style>

<style>
@media (max-width: 768px) {


    .radio label {
        padding-right: 7% !important;
    }

    button:focus {
        background: grey;
        font-family: comfortaa, sans-serif;
    }
}
@media (min-width: 768px) {


    .radio label {
        padding-right: 3% !important;
    }


}
</style>
